import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function PortalLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1 page-fade-in">{children}</main>
            <Footer />
        </div>
    );
}
